import {useMount as _useMount} from 'react-use';
import {notify} from '@gemcook/notification';

import utils from '@utils';
import constants from '@constants';

export const useMount = (me: MeStore, setCardInfo: any, setLoading: any) => {
  _useMount(async () => {
    utils.scroll.top();

    try {
      if (me.customerId !== '') {
        const hasCard = await utils.stripe.hasCard(me.customerId);
        if (hasCard) {
          const last4 = await utils.stripe.getCardInfo(me.customerId);
          setCardInfo(last4);
        }
      }
    } catch (err) {
      notify(constants.ERRORS.NETWORK, 'error');
    } finally {
      setLoading(false);
    }
  });
};
